module.exports = __webpack_public_path__ + "media/images/iconRight__inactive--dark-2034a85625459aa8d9dec2f3adf2350a.png";